import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, useMemo } from 'react';
import { AccordionPanel } from './AccordionPanel';
import { AccordionTitle } from './AccordionTitle';
import { AccordionContent } from './AccordionContent';
import cn from 'classnames';
import { useTheme } from '../Flowbite/ThemeContext';
const AccordionComponent = ({ children, flush }) => {
    const { theme: { accordion }, } = useTheme();
    const baseStyle = accordion.base;
    const flushStyle = {
        'rounded-lg border': !flush,
        'border-b': flush,
    };
    const panels = useMemo(() => Children.map(children, (child) => cloneElement(child, { flush })), [children, flush]);
    return (_jsx("div", { "data-testid": "accordion-element", className: cn(baseStyle, flushStyle), children: panels }));
};
AccordionComponent.displayName = 'Accordion';
AccordionPanel.displayName = 'Accordion.Panel';
AccordionTitle.displayName = 'Accordion.Title';
AccordionContent.displayName = 'Accordion.Content';
export const Accordion = Object.assign(AccordionComponent, {
    Panel: AccordionPanel,
    Title: AccordionTitle,
    Content: AccordionContent,
});
